(function () {
	'use strict';

	angular
		.module('wizard-english-test.services')
		.service('QuestionService', QuestionService)

	/** @ngInject */
	function QuestionService(HttpService) {
		const QuestionService = {
			getQuestion
		};

		return QuestionService;

		function getQuestion(leadCode) {
			return HttpService.get(`/questions/leads/code/${leadCode}`);
		}
	}
}());